export const MONTHLY = 'monthly'
export const BI_MONTHLY = 'bi_monthly'
export const MANUAL = 'manual'

export const CHARGING_DATE = [MANUAL, MONTHLY, BI_MONTHLY]
